var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h1',_vm._b({staticClass:"font-weight-bold",class:[_vm.$vuetify.breakpoint.mdAndUp ? 'display-3' : 'headline']},'h1',_vm.$attrs,false),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }